import React from 'react';
import {ResetButtonComponent} from './buttons/reset-button/reset-button.component';
import {StartOrbitButtonComponent} from './buttons/start-button/start-orbit-button.component';
import {SaveButtonComponent} from './buttons/save-button/save-button.component';
import Menu from '@material-ui/core/Menu';
import {LauncherComponentWithState} from '../base-components/launcher-component-with-state';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import IconButton from '@material-ui/core/IconButton'

export interface LauncherAppBarButtonsComponentProps {
    showButtonsElementRef: any;
}

export class LauncherAppBarButtonsComponent extends LauncherComponentWithState<{}, LauncherAppBarButtonsComponentProps> {

    state = {
        showButtonsElementRef: null
    };

    private _showButtonsMenu = (event) => {
        this.setState({showButtonsElementRef: event.currentTarget})
    };

    private _hideButtonsMenu = () => {
        this.setState({showButtonsElementRef: null})
    };

    private _renderOneButton(ButtonComponent, key: number) {
        return (<span key={key} onClick={this._hideButtonsMenu}>
            <ButtonComponent/>
        </span>);
    }

    private _getButtons() {
        return [
            this._renderOneButton(SaveButtonComponent, 10),
            this._renderOneButton(StartOrbitButtonComponent, 20),
            this._renderOneButton(ResetButtonComponent, 30)
        ];
    }
    private _renderPCButtons() {
        return (
            <div>
                {this._getButtons()}
            </div>
        );
    }



    private _renderMobileButtons() {
        return (
            <div>
                <IconButton color="inherit" onClick={this._showButtonsMenu}>
                    <MoreVertIcon/>
                </IconButton>
                <Menu open={Boolean(this.state.showButtonsElementRef)}
                      anchorEl={this.state.showButtonsElementRef}
                      onClose={this._hideButtonsMenu}>
                    {this._getButtons()}
                </Menu>
            </div>
        );
    }

    render() {
        if(this.services.deviceTypeDetection.isMobile) {
            return this._renderMobileButtons();
        } else {
            return this._renderPCButtons();
        }
    }
}